<div class="login-container">
  <!-- White Section for Login Form -->
  <div class="login-section white-section">
    <div class="form-container">
      <h1 class="login-title">{{ 'login.title' | translate }}</h1>

      @if (errorMessageKey) {
        <!-- Inline error banner placed at the top of the form (right under
             the title) so it's the first thing the user sees after a failed
             attempt — never buried below the submit button. Same UI for
             "user not found" and "wrong password" to avoid email-enumeration
             leaks. -->
        <div class="login-error" role="alert" id="login-error-banner">
          {{ errorMessageKey | translate }}
        </div>
      }

      <form nz-form [formGroup]="form" (ngSubmit)="login()" class="login-form" id="login-form">
        <div class="form-group">
          <label class="form-label" for="login-email-input">{{ 'login.email' | translate }}</label>
          <input
            nz-input
            formControlName="login"
            id="login-email-input"
            [placeholder]="'login.emailPlaceholder' | translate"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="login-password-input">{{
            'login.password' | translate
          }}</label>
          <div class="password-wrapper">
            <input
              nz-input
              [type]="passwordVisible ? 'text' : 'password'"
              formControlName="password"
              id="login-password-input"
              [placeholder]="'login.passwordPlaceholder' | translate"
              class="form-input"
            />
            <span
              nz-icon
              class="password-toggle"
              [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
              role="button"
              tabindex="0"
              [attr.aria-label]="
                (passwordVisible ? 'login.hidePassword' : 'login.showPassword') | translate
              "
              (click)="passwordVisible = !passwordVisible"
              (keydown.enter)="passwordVisible = !passwordVisible"
              (keydown.space)="passwordVisible = !passwordVisible; $event.preventDefault()"
              id="login-password-toggle"
            ></span>
          </div>
          <a
            class="forgot-password"
            routerLink="/forgot-password"
            id="login-forgot-password-link"
            >{{ 'login.forgotPassword' | translate }}</a
          >
        </div>

        <button
          nz-button
          type="submit"
          [disabled]="form.invalid || submitting"
          [nzLoading]="submitting"
          class="login-button"
          id="login-submit-button"
        >
          {{ 'login.loginButton' | translate }}
        </button>
        <!-- Self-service account creation is intentionally NOT exposed:
             accounts are provisioned by a company / restaurant admin via
             the back-office. The user receives an invitation email + sets
             their password via the standalone `/set-password` flow. -->
        <!-- A shared terminal has no password to type: it pairs once with an
             enrollment code, then only ever shows the PIN keypad. -->
        <a class="enroll-device-link" routerLink="/enroll-device" id="login-enroll-device-link">
          {{ 'login.enrollDevice' | translate }}
        </a>
      </form>
    </div>
  </div>

  <!-- Black Section for Branding -->
  <div class="login-section black-section">
    <div class="brand-content">
      <div class="logo-container">
        <img src="assets/logo/yuzeat.png" alt="Yuzeat" class="logo-image" />
      </div>

      <h2 class="marketing-title">
        {{ 'login.brandTitle' | translate }}<br />
        {{ 'login.brandSubtitle' | translate }}
        <span class="highlight-green">{{ 'login.brandTitleHighlight' | translate }}</span>
        {{ 'login.brandTitleSuffix' | translate }}
      </h2>

      <p class="marketing-subtitle">
        {{ 'login.brandDescription' | translate }}
        <span class="highlight-green">{{ 'login.brandDescriptionHighlight' | translate }}</span>
      </p>
    </div>
  </div>
</div>
